/* After Five - mobile collection card swipe (v7). Mobile + collection page only.
   Swipe through all photos/videos; a quick TAP on the image/video opens the product
   (a drag swipes instead). Keeps the theme's image sizing. */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  var grid = document.getElementById('product-grid');
  if (!grid) return;

  var css =
    '#product-grid .card__inner{position:relative!important;z-index:3!important;}' +
    '#product-grid .card__media{z-index:3!important;}' +
    '#product-grid .card__media .media--hover-effect{position:absolute!important;inset:0!important;z-index:2!important;display:flex!important;overflow-x:auto!important;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;touch-action:pan-x;scrollbar-width:none;cursor:pointer;}' +
    '#product-grid .card__media .media--hover-effect::-webkit-scrollbar{display:none;}' +
    '#product-grid .card__media .media--hover-effect > *{position:relative!important;inset:auto!important;top:auto!important;left:auto!important;flex:0 0 100%!important;width:100%!important;height:100%!important;scroll-snap-align:start;opacity:1!important;}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function playVideos(li) {
    li.querySelectorAll('.media--hover-effect video').forEach(function (v) {
      try {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      } catch (e) {}
    });
  }

  function getUrl(li) {
    var link = li.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href') : null;
  }

  function loadImages(li) {
    var track = li.querySelector('.media--hover-effect');
    var url = getUrl(li);
    if (!url || !track || track.dataset.afLoaded) return;
    track.dataset.afLoaded = '1';
    var handle = url.split('/products/')[1].split(/[?#]/)[0];
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var have = track.querySelectorAll('img').length;
        (p.media || [])
          .filter(function (m) { return m.media_type === 'image'; })
          .forEach(function (m, i) {
            if (i < have) return;
            var u = m.src + (m.src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
            var img = document.createElement('img');
            img.src = u;
            img.loading = 'lazy';
            img.alt = '';
            img.className = 'motion-reduce';
            track.appendChild(img);
          });
      })
      .catch(function () {});
  }

  /* tap (no drag) on the image/video opens the product; a drag swipes. */
  function addTap(li) {
    var track = li.querySelector('.media--hover-effect');
    var url = getUrl(li);
    if (!track || !url || track.dataset.afTap) return;
    track.dataset.afTap = '1';
    var sx = 0, sy = 0, moved = false;
    track.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; moved = false;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      var t = e.changedTouches[0];
      if (Math.abs(t.clientX - sx) > 8 || Math.abs(t.clientY - sy) > 8) moved = true;
    }, { passive: true });
    track.addEventListener('touchend', function () {
      if (!moved) { window.location.href = url; }
    }, { passive: true });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { loadImages(e.target); playVideos(e.target); }
    });
  }, { rootMargin: '1000px' });

  grid.querySelectorAll('li').forEach(function (li) {
    io.observe(li);
    addTap(li);
  });
})();
